export default __webpack_public_path__ + "static/media/purge.46a86493.png";